module.exports = __webpack_public_path__ + "img/bb_g3_tail.42bc760f.svg";